import LocalizedStrings from 'react-localization';

import * as ro from './ro';

const Localization = new LocalizedStrings({ ro });

export function SetLanguage(language: string) {
  return Localization.setLanguage(language);
}

export default Localization;
